// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FnIDM","name":"styles_name__245T6","phone":"styles_phone__1Bwfx"};